import { useEffect, useState } from 'react';
import DotMenu, { Options } from '../primitives/dotMenu/DotMenu';
import ActionDropdown from '../primitives/dropdowns/ActionDropdown';
import userIcon from '../../assets/user-group.svg';
import ToastNotification from '../Reusable/ToastNotification';
import { MenuConstants } from '../../constants/MenuConstants';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AppConstants } from '../../constants/AppConstants';
import { useAppSelector } from '../../app/hooks';
import { checkForPermission } from '../../util/permissionUtils';

interface AdminMenuProps {
  className?: string;
  iconSize?: string;
  userId: any;
  onOptionClick?: Function;
  dropdownMenu?: boolean;
  disabled?: boolean;
  showEdit?: boolean;
}

const AdminMenu: React.FC<AdminMenuProps> = ({
  iconSize = '',
  userId,
  className = '',
  onOptionClick = () => {},
  dropdownMenu = false,
  disabled = false,
  showEdit = false
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const veiwEnrollModalPermission = [
    AppConstants.PERMISSION_UMS_GET_USER_DETAILS_BY_ID,
    AppConstants.PERMISSION_UMS_ENROLL_ORG,
    AppConstants.PERMISSION_UMS_UNENROLL_ORG
  ];

  let options: Array<any> = [];

  const permissionForEnroll = checkForPermission(veiwEnrollModalPermission);

  if (permissionForEnroll) {
    options = [
      {
        display: `${t('T_USER_MANAGE_ENROLL_ORG')}`,
        key: MenuConstants.MENU_ENROLL_ORGANIZATIONS
      }
    ];
  }
  if (showEdit) {
    options.push({
      display: `${t('T_EDIT')}`,
      key: MenuConstants.MENU_EDIT_USER
    });
  }

  const [selectedOption, setSelectedOption] = useState<Options | null>();

  useEffect(() => {
    if (selectedOption) {
      switch (selectedOption.key) {
        case MenuConstants.MENU_ENROLL_ORGANIZATIONS:
          if (onOptionClick) {
            onOptionClick(MenuConstants.MENU_ENROLL_ORGANIZATIONS);
          }
          break;
        case MenuConstants.MENU_EDIT_USER:
          if (onOptionClick) {
            onOptionClick(MenuConstants.MENU_EDIT_USER);
          }
          break;
      }
    }
  }, [selectedOption]);

  options.push({
    display: `${t('T_VIEW_SETTINGS')}`,
    key: MenuConstants.MENU_VIEW_SETTINGS,
    action: () => {
      navigate(`/users/${userId}/config-key-list`);
    }
  });

  const [toasterMessage, setToasterMessage] = useState('');
  const [isToastActive, setIsToastActive] = useState(false);
  const [toasterType, setToasterType] = useState<any>('success');

  return (
    <>
      <ToastNotification
        message={toasterMessage}
        isActive={isToastActive}
        setIsActive={setIsToastActive}
        status={toasterType}
      />
      <div>
        {/* <DotMenu
          options={options}
          onSelectedOptionChange={(value) => {
            setSelectedOption(value);
          }}
          value={selectedOption}
          containerClassName={className}
          iconSize={iconSize}
        /> */}

        {dropdownMenu ? (
          <ActionDropdown
            className={disabled ? 'disabled' : ''}
            options={options}
            onSelectedOptionChange={(value: any) => {
              setSelectedOption(value);
            }}
            value={selectedOption}
            defaultLabel={t('T_MANAGE_USER_DETAILS')}
          />
        ) : (
          <DotMenu
            options={options}
            onSelectedOptionChange={(value) => {
              setSelectedOption(value);
            }}
            containerClassName={className}
            value={selectedOption}
            dropDownStyle={{ left: '35px', top: '35px' }}
          />
        )}
      </div>

      {selectedOption?.key === MenuConstants.MENU_VIEW_SETTINGS &&
        navigate(`/users/${userId}/config-key-list`)}

      {/* {selectedOption?.key === MenuConstants.MENU_VIEW_CATEGORIES &&
        navigate(`/users/${userId}/config-category-list`)} */}
    </>
  );
};

export default AdminMenu;
